import Container = PIXI.Container;
import Rectangle = PIXI.Rectangle;
import { Button } from './Button';

export class CloseButton extends Button {
  private xIcon: PIXI.Sprite;

  constructor(callback?: () => any, parent?: Container) {
    super('popup_close_btn', callback, null, true, true, 1);
    if (parent) {
      parent.addChild(this);
    }
  }

  protected drawLayout(): void {
    super.drawLayout();
    this.hitArea = new Rectangle(
      this.defaultSkin.x - this.defaultSkin.width / 2,
      this.defaultSkin.y - this.defaultSkin.height / 2,
      this.defaultSkin.width * 2,
      this.defaultSkin.height * 2
    );
  }
}